import { API } from "@/lib/api";

/** Build a URL to fetch a file via backend endpoint. Uses cookie auth by default. */
export function fileUrl(fileId) {
  return `${API}/files/${fileId}`;
}
